window.mainCollectionModule = (() => {
  function handleNavigationTree() {
    document.addEventListener("DOMContentLoaded", () => {
      const scriptTag = document.querySelector("#navigation-data");
      const data = JSON.parse(scriptTag.textContent);
      const { navigationData } = data;
      const { currentCollection } = data;

      // Recursive function to find current collection and its direct parent
      function findCollectionAndParent(data, currentCollection) {
        for (const item of data) {
          if (item.handle === currentCollection) {
            return { parent: null, current: item };
          }
          if (item.links) {
            for (const link of item.links) {
              if (link.handle === currentCollection) {
                return { parent: item, current: link };
              }
              // Recursively search within the nested links
              const result = findCollectionAndParent(link.links, currentCollection);
              if (result.current) {
                return { parent: item, current: result.current };
              }
            }
          }
        }
        return { parent: null, current: null };
      }

      const { parent: directParent, current: currentItem } = findCollectionAndParent(navigationData, currentCollection);

      if (!directParent && !currentItem) {
        console.error("Direct parent or current collection not found.");
        return;
      }

      // Inject links into the navigation container
      const navContainer = document.querySelector(".collection__navigation");
      if (!navContainer) {
        console.error("Navigation container not found.");
        return;
      }
      function hasCurrentCollection(link_level_2) {
        if (link_level_2.links && link_level_2.links.length > 0) {
          // Use 'some' for early exit if any link matches the currentCollection
          return link_level_2.links.some((link) => link.handle === currentCollection);
        }
        return false;
      }
      // Function to render the navigation items
      function renderNavigationItems(items, level) {
        items.forEach((item) => {
          const levelClass = `collection__navigation-level-${level}`;
          const linkElement = document.createElement("a");

          linkElement.className = `${levelClass} ${
            item.handle === currentCollection ? "collection__navigation-current-link" : ""
          }`;
          linkElement.href = item.url;
          linkElement.textContent = item.title;
          navContainer.appendChild(linkElement);

          if (item.level === "2" && (hasCurrentCollection(item) || item.handle === currentCollection)) {
            renderNavigationItems(item.links, level + 1);
          } else if (item.level !== "2") {
            if (item.links && item.links.length > 0) {
              renderNavigationItems(item.links, level + 1);
            }
          }
        });
      }

      // Render the direct parent and its children
      if (directParent) {
        renderNavigationItems([directParent], 1);
      } else if (currentItem) {
        renderNavigationItems([currentItem], 1);
      }
    });
  }

  function initNavigationTree() {
    handleNavigationTree();
  }
  initNavigationTree();

  // Public API
  return {
    initNavigationTree,
  };
})();
